// extracted by mini-css-extract-plugin
export default {"main":"LoggedInRoot_main__rwye8"};